module.exports = __webpack_public_path__ + "img/img1.bf41c6ac.jpg";